// extracted by mini-css-extract-plugin
export var statItem = "_d4-1";
export var statsRow = "_d4-0";